import { MDBBtn, MDBDataTable, MDBIcon } from "mdbreact"
import React from 'react'
import Select from 'react-select'
import { Card, CardBody, Col, Collapse, Container, Form, Input, Media, Label, Row } from 'reactstrap'
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import _valid from "../../validations"
import Lightbox from 'react-image-lightbox'
import { withRouter }  from 'react-router-dom'
import { result } from "lodash"
import { Link } from "react-router-dom";


const columns = [
    {
        label: "Realizado por",
        field: "colaborador_que_asigna_nombre",
        sort: "asc"
    },
    {
        label: "Asignado a",
        field: "colaborador_que_recibe_nombre",
        sort: "asc"
    },
    {
        label: "Movimiento",
        field: "comentario",
        sort: "asc"
    },
    {
        label: "Estado",
        field: "estado_nombre",
        sort: "asc"
    },
    {
        label: "Fecha de Registro",
        field: "fecha_registro_str",
        sort: "asc"
    }
];

const columns_area = [
    {
        label: "Departamento/Area",
        field: "departamento_area_nombre",
        sort: "asc",
        width: 150,
    },
    {
        label: "Ubicación Fisica",
        field: "area_trabajo_nombre",
        sort: "asc",
        width: 150,
    },
];

const columns_reparaciones = [
    {
        label: "Código Solicitud",
        field: "id",
        sort: "asc"
    },
    {
        label: "Nombre",
        field: "titulo",
        sort: "asc"
    },
    {
        label: "Fecha de Solicitud",
        field: "fecha_creacion_str",
        sort: "asc"
    },
    {
        label: "Prioridad",
        field: "prioridad_nombre",
        sort: "asc"
    },
    /*  
        label: "Tipo Solicitud",
        field: "tipo_solicitud_nombre",
        sort: "asc"
    } */
    {
        label: "Fecha Programada",
        field: "fecha_programada_str",
        sort: "asc"
    },
    {
        label: "Asignado a",
        field: "colaborador_nombre",
        sort: "asc"
    },
    {
        label: "Ubicación",
        field: "lugar_ubicacion_nombre",
        sort: "asc"
    },
    {
        label: "Departamento / Área",
        field: "asignado_a_nombre",
        sort: "asc"
    },
    {
        label: "Estado",
        field: "estado_nombre",
        sort: "asc"
    }
];

export default class ArticuloDetalles extends React.Component {

    constructor(props) {
        super(props)

        this.apiRest = new ApiRest(props);

        const id = this.props.match.params.id;

        props = _valid(props, props.props) ? props.props : props;
        this.state = {            
            articuloID: id,
            articuloDetalle: {
                codigo: null,
                nombre: null,
                marca: null,
                serie: null,
                descripcion: null
            },
            imgNuevaArticuloBase64: null,
            verImagenEnGrande: false,
            colapsarAsignado: false,
            colapsarUbicacion: false,
            colapsarReparaciones: false,
        };
    }

    componentDidMount() {        
        this.buscar();
    }

    buscar = async () => {
        const {
            articuloID
        } = this.state

        this.apiRest.get('/articulo/'+ articuloID).then(resultado => {
            if (resultado.exitoso) {
                this.setState({ articuloDetalle: resultado.data})
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });

        if (_valid(articuloID)) {
            this.imagen("/getImagen/" + articuloID, "GET", " ").then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ imgNuevaArticuloBase64: resultado.imgNuevaBase64 });
                }
            });
        }
        
        this.apiRest.get('/historialArticuloAsignado/'+ articuloID).then(resultado => {
            if (resultado.exitoso) {
                this.setState({ tabla: {columns, rows: resultado.data } })
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });

        this.apiRest.get('/articuloAreasTrabajo/' + articuloID).then(resultado => {
            if (resultado.exitoso) {
                this.setState({ tabla_areas: {columns: columns_area, rows: resultado.data } })
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });

        this.apiRest.get('/articuloReparaciones/' + articuloID).then(resultado => {
            if (resultado.exitoso) {
                this.setState({ tabla_reparaciones: {columns: columns_reparaciones, rows: resultado.data } })
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
        
    }

    imagen = async (url, method) => {
        return await fetch(process.env.REACT_APP_API_URL + url, {
            method: method
        })
            .then(async response => {
                if (response.status >= 200 && response.status < 300) {
                    return await response.json()
                        .then(dato => ({
                            exitoso: true,
                            data: dato.datosSerializados,
                            imgNuevaBase64: dato.imgNuevaArticuloBase64
                        }))
                        .catch(error => ({ exitoso: false, response, error }));
                } else if (response.status === 401) {
                    this.props.history.push('/logout');
                } else {
                    return await response.json()
                        .then(dato => ({ exitoso: false, response, data: dato }))
                        .catch(error => ({ exitoso: false, response, error }));
                }
            })
            .catch(error => ({ "exitoso": false, error }));
    }

    colapsarTablaAsociaciones = estadoAColapsar => {
        this.setState(estadoAnterior => ({ ...estadoAnterior, [estadoAColapsar]: !estadoAnterior[estadoAColapsar] }));
    }

    render() {
        const {
            articuloID,
            imgNuevaArticuloBase64,
            verImagenEnGrande,
            colapsarAsignado,
            colapsarUbicacion,
            colapsarReparaciones
        } = this.state;

        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        {this.state.timeralert}
                        <Breadcrumbs title="Activos" breadcrumbItem={"Detalles del Articulo"} />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <Row>
                                            <Col lg={4}>
                                                <div className="mb-3 mb-4">
                                                    <Label htmlFor="codigo" className="form-label">
                                                        Código
                                                    </Label>
                                                    <Input
                                                        value={this.state.articuloDetalle.codigo}
                                                        name="codigo"
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="---"
                                                        required={true}
                                                    />
                                                </div>
                                            </Col>
                                            <Col lg={4}>
                                                <div className="mb-3 mb-4">
                                                    <Label htmlFor="nombre" className="form-label" >
                                                        Nombre
                                                    </Label>
                                                    <Input
                                                        value={this.state.articuloDetalle.nombre}
                                                        name="nombre"
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="---"
                                                    />
                                                </div>
                                            </Col>
                                            <Col lg={4}>
                                                <div className="mb-3 mb-4">
                                                    <Label htmlFor="marca" className="form-label">
                                                        Marca
                                                    </Label>
                                                    <Input
                                                        value={this.state.articuloDetalle.marca}
                                                        name="marca"
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="---"
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg={4}>
                                                <div className="mb-3 mb-4">
                                                    <Label htmlFor="serie" className="form-label">
                                                        Serie
                                                    </Label>
                                                    <Input
                                                        value={this.state.articuloDetalle.serie}
                                                        name="serie"
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="---"
                                                    />
                                                </div>
                                            </Col>
                                            <Col lg={4}>
                                                <div className="mb-3 mb-4">
                                                    <Label htmlFor="descripcion" className="form-label">
                                                        Descripción
                                                    </Label>
                                                    <Input
                                                        value={this.state.articuloDetalle.descripcion}
                                                        name="descripcion"
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="---"
                                                    />
                                                </div>
                                            </Col>
                                            <Col lg={4}></Col>
                                            <Col lg={2}>
                                                <div onClick={() => this.setState({ verImagenEnGrande: true })}>
                                                    {imgNuevaArticuloBase64 && <img width="100%" src={`data:image/jpeg;base64,${imgNuevaArticuloBase64}`} alt="articulo" />}
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                                <Card>
                                    <CardBody>
                                        <Link onClick={() => this.colapsarTablaAsociaciones("colapsarUbicacion")} className="text-dark" to="#">
                                            <div>
                                                <Media className="d-flex align-items-center">
                                                    <div className="flex-1 overflow-hidden">
                                                        <h5 className="font-size-16 mb-1">Ubicación</h5>
                                                    </div>
                                                    <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                </Media>
                                            </div>
                                        </Link>
                                        <hr/>
                                        <Collapse isOpen={colapsarUbicacion}> 
                                            <Row>
                                                <Col lg={12}>                                                            
                                                    <div className="table-responsive">
                                                        <MDBDataTable hover searchLabel="Buscar.." paginationLabel={["Anterior", "Siguiente"]} noRecordsFoundLabel="No hay datos." infoLabel={["Mostrando desde ", "hasta", " | Entradas totales: ", ""]} entriesLabel="--Mostrando entradas" 
                                                        data={this.state.tabla_areas} />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Collapse>
                                    </CardBody>
                                </Card>
                                <Card>
                                    <CardBody> 
                                        <Link onClick={() => this.colapsarTablaAsociaciones("colapsarAsignado")} className="text-dark" to="#">
                                            <div>
                                                <Media className="d-flex align-items-center">
                                                    <div className="flex-1 overflow-hidden">
                                                        <h5 className="font-size-16 mb-1">Historial de Responsable</h5>
                                                    </div>
                                                    <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                </Media>
                                            </div>
                                        </Link>
                                        <hr/>
                                        <Collapse isOpen={colapsarAsignado}>                                           
                                            <Row>
                                                <Col lg={12}>                                                            
                                                    <div className="table-responsive">
                                                        <MDBDataTable hover searchLabel="Buscar.." paginationLabel={["Anterior", "Siguiente"]} noRecordsFoundLabel="No hay datos." infoLabel={["Mostrando desde ", "hasta", " | Entradas totales: ", ""]} entriesLabel="--Mostrando entradas" 
                                                        data={this.state.tabla} />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Collapse>
                                    </CardBody>
                                </Card>
                                <Card>
                                    <CardBody> 
                                        <Link onClick={() => this.colapsarTablaAsociaciones("colapsarReparaciones")} className="text-dark" to="#">
                                            <div>
                                                <Media className="d-flex align-items-center">
                                                    <div className="flex-1 overflow-hidden">
                                                        <h5 className="font-size-16 mb-1">Reparaciones</h5>
                                                    </div>
                                                    <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                </Media>
                                            </div>
                                        </Link>
                                        <hr/>
                                        <Collapse isOpen={colapsarReparaciones}>                                           
                                            <Row>
                                                <Col lg={12}>                                                            
                                                    <div className="table-responsive">
                                                        <MDBDataTable hover searchLabel="Buscar.." paginationLabel={["Anterior", "Siguiente"]} noRecordsFoundLabel="No hay datos." infoLabel={["Mostrando desde ", "hasta", " | Entradas totales: ", ""]} entriesLabel="--Mostrando entradas" 
                                                        data={this.state.tabla_reparaciones} />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Collapse>
                                    </CardBody>
                                </Card>                               
                            </Col>
                        </Row>
                    </Container>
                </div>
                {verImagenEnGrande && <Lightbox mainSrc={`data:image/jpeg;base64,${imgNuevaArticuloBase64}`} onCloseRequest={() => this.setState({ verImagenEnGrande: false })} />}
            </React.Fragment>
        )
    }
}